import {initMultifavorites} from "../../../../../module/dcshop/Favorites/js/multifavorites";

window.addEventListener("load", (event) => {

    initMultifavorites();

});
